<template>
<div class="banner">
    <NuxtErrorBoundary @error="$handleSwiper">
        <swiper
            v-bind="swiperOptions"
            class="mySwiper">
            <swiper-slide>
                <div class="text-center">
                    <div class="img-container">
                        <img  src="~/assets/footer/payment_banner/paypal.svg" alt="paypal">
                    </div>
                    <p class="mt-3">Checkout securely via your Paypal account or Buy Now, Pay Later in interest-free installments.</p>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="text-center">
                    <div class="img-container">
                        <img  src="~/assets/footer/payment_banner/split_payment.svg" alt="split_payment">
                    </div> 
                    <p class="mt-3">Conveniently pay with Visa, MasterCard, American Express, and other major cards.</p>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="text-center">
                    <div class="img-container">
                        <img  src="~/assets/footer/payment_banner/affirm.svg" alt="affirm">
                    </div>
                    <p class="mt-3">Choose from various monthly repayment plans with rates as low as 0% APR for qualified buyers.</p>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="text-center">
                    <div class="img-container">
                        <img width="100" height="45" src="~/assets/footer/payment_banner/splitit.svg" alt="splitit">
                    </div>
                    <p class="mt-3">Split costs into monthly payments with no interest or fees using your existing credit card.</p>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="text-center">
                    <div class="img-container">
                        <img width="140" height="45" src="~/assets/footer/payment_banner/afterpay.svg" alt="afterpay">
                    </div>
                    <p class="mt-3">Split your total order value into four payments over six weeks at checkout for added ease.</p>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="text-center">
                    <div class="img-container">
                        <img  src="~/assets/footer/payment_banner/wiretransfer.svg" alt="wire transfer">
                    </div>
                    <p class="mt-3">Enjoy a 2% discount pre-tax on cart value when you choose BankWire payments within the US.</p>
                </div>
            </swiper-slide>
        </swiper>
    </NuxtErrorBoundary>
</div>

</template>

<script setup>

    const swiperOptions = {
    // loop:true,
    spaceBetween: 20,
    modules: [SwiperAutoplay],
    centerInsufficientSlides: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        512: {
            slidesPerView: 2.2,
        },
        768: {
            slidesPerView: 2.9,
        },
      
        1300: {
            slidesPerView: 6,
            spaceBetween: 40
        },
    },
    };
</script>

<style scoped>

    .img-container{
        min-height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    img {
        max-width: 100%;
        height: auto;    
        object-fit: contain;
    }

    p{
        color: #353535;
        font-size: 14px;  
        line-height: 1.5;
    }
    @media (max-width:512px){
        p{
            padding: 0 30px 0 30px;
        }
    }
</style>